import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full sm:w-1/2 xl:w-1/3" }
const _hoisted_2 = { class: "border-teal p-8 border-t-12 mb-6 rounded-lg shadow-lg bg-white" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "font-bold text-grey-darker block mb-2" }, "Email", -1)
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "font-bold text-grey-darker block mb-2" }, "Password", -1)
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mt-2 text-sm leading-5" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\"><div class=\"absolute inset-0 flex items-center\"><div class=\"w-full border-t border-gray-300\"></div></div><div class=\"relative flex justify-center text-sm leading-5\"><span class=\"px-2 bg-white text-gray-500\">Or continue with</span></div></div>", 1)
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = { class: "mt-6" }
const _hoisted_15 = { class: "block w-full rounded-md shadow-sm" }
const _hoisted_16 = { class: "mt-6" }
const _hoisted_17 = { class: "block w-full rounded-md shadow-sm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow",
          placeholder: "Your email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.email = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          type: "password",
          class: "block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow",
          placeholder: "Your password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.password = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("a", {
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.handleSignup({ email: _ctx.email, password: _ctx.password }))),
          href: "#",
          class: "btn-black",
          tabindex: "0"
        }, " Sign up "),
        _createVNode("a", {
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.handleLogin({ email: _ctx.email, password: _ctx.password }))),
          href: "#",
          class: "btn-black-outline"
        }, [
          (_ctx.password.length)
            ? (_openBlock(), _createBlock("span", _hoisted_8, "Sign in"))
            : (_openBlock(), _createBlock("span", _hoisted_9, " Send magic link "))
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("a", {
          onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.handlePasswordReset(...args)), ["prevent"])),
          href: "/",
          class: "font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
        }, " Forgot your password? ")
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, [
              _createVNode("button", {
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.handleOAuthLogin('github'))),
                type: "button",
                class: "w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              }, " GitHub ")
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("span", _hoisted_17, [
              _createVNode("button", {
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.handleOAuthLogin('google'))),
                type: "button",
                class: "w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              }, " Google ")
            ])
          ])
        ])
      ])
    ])
  ]))
}